export { WatchTheatricalView } from './WatchTheatricalView'
export { DigitalStreamingView } from './DigitalStreamingView'
